<template>
  <div
    v-if="user"
    :class="`user-badge user-badge-status--${user?.sessionStatus && !noStatus ? sessionStatusClassNamesMap[user.sessionStatus] : 'none'} ${
      variant ? 'user-badge--small' : ''
    } ${isCurrentUserRef ? 'user-badge--current-user' : ''}`"
  >
    <Avatar :user="user" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useAccount from '@/features/auth/hooks/use-account.hook'
import type { V2SessionType } from '@/features/sessions/types'
import { sessionStatusClassNamesMap } from '@/features/sessions/utils'
import Avatar from '@/features/users/components/avatar/avatar.vue'
import type { V2UserDataType } from '@/features/users/types'

const props = defineProps<{
  user: (V2UserDataType & { sessionStatus?: V2SessionType['users'][number]['sessionStatus'] }) | undefined
  variant?: 'small'
  noStatus?: boolean
}>()

const { accountRef } = useAccount()

const isCurrentUserRef = computed(() => accountRef.value?.id === props.user?.id)
</script>

<style lang="scss">
@import './user-badge.scss';
</style>
